///<reference path="../short-cuts/index.d.ts"/>

module Meevo.Components.Controls {
    "use strict";

    import IDataMaintenanceContext = Meevo.Components.BaseClasses.IDataMaintenanceContext;
    import IShowFormOptionRow = Meevo.Plugins.DocsAndForms.IShowFormOptionRow;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;

    export interface IMaintenanceFormCustomButton {
        text: string,
        clickHandler(),
        classNames: string,
        disableRules: () => boolean,
        visibilityRules: () => boolean,
        securityRules: string,
        position: string
    }

    export interface IMaintenanceFormCustomFooterInfo {
        template: string;
        className: string;
        visibilityRules: () => boolean;
        position: string;
    }

    export class MeevoMaintenanceForm implements angular.IDirective {
        private securityKeys = Meevo.Components.Common.SecurityKeys;

        restrict = "E";
        scope = {
            context: "=",
            shortCutGroup: "=",
            searchContext: "=",
            headerContentKey: "@",
            visualState: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            disableCrud: "=",
            hideSearch: "=",
            showCoBar: "=?",
            closeInterceptor: "&?",
            customButtonsSet: "=?",
            customFooterInfo: "=?",
            templateUrl: "@?",
            headerTemplateUrl: "@?",
            dashboardTemplateUrl: "@?",
            isMiscSupply: "=?",
            auditNoun: "@?",
            backArrow: "&?",
            backArrowHide: "@?",
            displayBackArrow: "=?",
            showMobileBreadcrumbs: "=?",
            isLightBg: "<?",
            invalidFieldCheck: "&",
            disableAuditHistory: '=?',
            customAuditCriteria: '=?'
        };

        templateUrl = (elem, attrs) => {
            return attrs.templateUrl || 'app/components/controls/maintenanceFormTemplate.html';
        };

        require = '^form';

        link = (scope: any, element: angular.IAugmentedJQuery, attributes: angular.IAttributes, formCtrl: any) => {
            let doSubmitForm: boolean = false;

            scope.display = {};
            scope.display.empDropdown = false;
            scope.display.dropdown = false;
            scope.display.auditDropdown = false;
            scope.auditHistorySecurityKey = this.securityKeys.MANAGEMENT_AUDITHISTORY;
            
            // Can override template
            if (!_.isUndefined(scope.templateUrl)) {
                scope.templateUrl = 'app/components/controls/maintenanceFormTemplate.html';
            }
            // Can override header template
            if (Model.Guard.isNothing(scope.headerTemplateUrl)) {
                scope.headerTemplateUrl = 'app/components/controls/maintenanceFormHeaderTemplate.html';
            }
            // Can override dashboard template
            if (_.isUndefined(scope.dashboardTemplateUrl)) {
                scope.dashboardTemplateUrl = 'app/components/controls/maintenanceFormDashboardTemplate.html';
            }

            // data maintenance form for searchable entity
            if (_.isUndefined(scope.showCoBar))
                scope.showCoBar = true;


            // Exposes compiled handlebars template
            scope.applySearchResultTemplate = (item: any): string => {
                if (scope.context && scope.context.searchResultTemplateFunction) {
                    return scope.context.searchResultTemplateFunction(item);
                } else {
                    return "";
                }
            }
            scope.shouldDisplayPluginDashboard = (shouldDisplay) => {
                scope.showAuditHistory();
                scope.displayPluginDashboard = shouldDisplay;
            }

            // non-searchable data maintenance form will not support quick dropdown results
            scope.showMobileMenu = (forceSet = true) => {
                if (!forceSet) return scope.mobileMenu = false; //ios not closing. trying to force close menu
                scope.mobileMenu = !scope.mobileMenu;
            }

            scope.closeAuditHistory = () => {
                scope.display.auditDropdown = false;
            }

            scope.isMobile = () => {
                return device.mobile();
            }

            scope.isAuditSecurityHide = () => {
                if (Model.Guard.isSomething(scope.auditHistorySecurityKey)
                    && Model.Guard.isSomething(scope.context)
                    && Model.Guard.isSomething(scope.context.securityChecker)
                    && scope.context.securityChecker.hasSecurity(scope.auditHistorySecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ, Meevo.Model.SecurityAccessEnum.Hide)) {
                    return true;
                }
                else {
                    return false;
                }
            }

            scope.showAuditHistory = () => {
                if (scope.context.isAdding || scope.disableAuditHistory) return;
                //if(!device.mobile()) scope.display.auditDropdown = !scope.display.auditDropdown;
                scope.display.auditDropdown = !scope.display.auditDropdown;
                let request = {
                    asLocationId: scope.context.asLocationId,
                    itemsPerPage: 30,
                    pageNumber: 0,
                    criteria: {
                        entityId: scope.context.itemId,
                        startDate: moment().subtract(2, "years").toDate(),
                        endDate: moment().toDate(),
                        purpose: Meevo.Model.PurposeEnum.Audit,
                        nounId: scope.auditNoun || scope.context.auditNoun || null,
                    }
                }

                if (scope.customAuditCriteria) {
                    request.criteria.nounId = scope.customAuditCriteria.nounId || request.criteria.nounId;
                }

                /*  TODO:   Revise & Refactor Like ActivityLog  */

                scope.auditHistory = [];
                scope.auditHistoryLoading = true;
                this.dataService.customMethodData("api/ActivityLog/DataChange/List/", "post", request).then((res) => {
                    scope.auditHistory = res.data;
                    if (!device.mobile()) scope.display.auditDropdown = true;
                }).finally(() => {
                    scope.auditHistoryLoading = false;
                });
            }

            scope.openAuditModal = () => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/auditHistory/auditHistory.html",
                    locals: {
                        auditLog: scope.auditHistory,
                        userId: this.identityService.current().userId,
                        //auditcreatedrecord: entitycreatedresponse.data,
                        userName: this.identityService.current().userAuthName
                    },
                    controller: "meevo.auditHistory.AuditHistoryController",
                    controllerAs: "auditHistory",
                    bindToController: true
                }
                this.modalService.showCustom(options);
            }

            scope.$watch(() => formCtrl.$pending, (newVal) => {
                if (!newVal && doSubmitForm) {
                    scope.submitForm();
                }
            });

            scope.submitForm = (): void => {
                doSubmitForm = false;

                // wait for finish of the async validations
                if (typeof formCtrl.$pending === 'object') {
                    doSubmitForm = true;
                    return;
                }

                angular.forEach(formCtrl, function (value, key) {
                    if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue'))
                        formCtrl[key].$dirty = true;
                });

                if (formCtrl.$valid && !formCtrl.$pending) {
                    try {
                        this.busyService.start();
                        scope.context.save().finally(() => {
                            //scope.context.trackingService.saveTrackingInfo();
                            this.busyService.stop();
                        });
                    } catch (ex) {
                        scope.context.loadingInProgress = false;
                        console.debug('Save Exception Occured: ', ex);
                    } finally {
                        this.busyService.stop();
                    }
                }

                else if (!formCtrl.$valid) {
                    if (Meevo.Model.Guard.isSomething(scope.invalidFieldCheck) && scope.invalidFieldCheck()) {
                        return;
                    }
                    this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION", 0, true);
                    angular.element(".meevo-maint-center").scrollTop(angular.element("[name='maintenanceForm']").find(".ng-invalid")[0].offsetTop);
                } 
            }

            scope.cancel = (): void => {
                scope.context.cancel();
                formCtrl.$setPristine();
            }

            scope.detail = (id: Guid, atLocationId: number = null): void => {
                scope.selectedItemId = id;
                if (atLocationId) {
                    scope.context.atLocationId = atLocationId;
                }
                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;

                setTimeout(() => {
                    scope.display.dropdown = false;
                }, 300)

            }

            scope.search = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    doSearch();
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            doSearch();
                        })
                }

            }

            scope.closeContext = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                        })
                }
            }

            function doSearch() {
                scope.selectedItemId = null;
                scope.visualState = Model.MaintenanceFormVisualState.Search;

                if (scope.context.selectedSection != null) {
                    scope.context.selectedSection.currentlySelectedTab = null;
                    if (scope.context.selectedSection.model != null) {
                        scope.context.selectedSection.model = null;
                    }
                }
            }

            scope.$watch(() => {
                return formCtrl.$error;
            }, (newVal) => {
                scope.validationErrorList = newVal;
            }, true)

            if(scope.shortCutGroup) {
                this.shortCutsService.maintenanceFormDirectiveWrapper(scope);
            }

            if (_.isUndefined(scope.displayBackArrow)) scope.displayBackArrow = false;
            if (_.isUndefined(scope.backArrowHide)) scope.backArrowHide = 'hide-gt-xs';

            scope.isLightBg = _.isUndefined(scope.isLightBg) ? false : true;
        }

        private iframeEventHandler;
        private formLaunched: boolean = false;
        public iframeCallback?: Function;

        constructor(private $rootScope: angular.IRootScopeService,           
            private $state: angular.ui.IStateService,           
            private $document: angular.IDocumentService,
            private busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.Common.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private docsAndFormsService: DocsAndFormsService) {

            // Create IE + others compatible event handler
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';            
            // Listen to message from child window
            this.iframeEventHandler = (event: MessageEvent) => {
                if (event.data.n == undefined || event.data.n == null) return;
                this.formLaunched = true;
                if (this.iframeCallback) {
                    this.iframeCallback();
                }
                this.$rootScope.$apply();               
                this.openForm(event.data);
            }
            eventer(messageEvent, this.iframeEventHandler, false);
        }

        openForm(postData: any) {
            const showFormRow: IShowFormOptionRow = {
                formDisplayName: postData.n,
                formId: postData.f,
                formUrl: postData.u,
                serviceId: postData.s
            };
            //console.log('showFormRow',  showFormRow);
            this.docsAndFormsService.showForm(showFormRow, postData.c).then(() => {
                this.loadForms();
            });
        }
        loadForms: () => void;
        static factory(): angular.IDirectiveFactory {
            let directive = ( $rootScope: angular.IRootScopeService, $state: angular.ui.IStateService,
                $document: angular.IDocumentService, busyService: Meevo.Components.Busy.IBusyService,
                dataService, modalService, $window,
                identityService, shortCutsService, docsAndFormsService) => {
                return new MeevoMaintenanceForm($rootScope, $state,
                    $document, busyService,
                    dataService, modalService,
                    identityService, shortCutsService, docsAndFormsService);
            };

            directive.$inject = ["$rootScope", "$state",
                "$document", "meevo.components.busy.BusyService",
                "meevo.components.common.DataService", "meevo.components.modal.ModalService", "$window",
                "meevo.components.common.IdentityService", "meevo.components.short-cuts.ShortCutsService", "meevo.plugins.docsAndForms.DocsAndFormsService"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMaintenanceForm", MeevoMaintenanceForm.factory());
}
